var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.initFinish),expression:"!initFinish"}],staticClass:"page-container"},[(_vm.initFinish && _vm.isMobile)?_c('mobileHomePage'):(_vm.initFinish)?_c('pcHomePage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }